import { createFeature, createReducer, on } from '@ngrx/store';

import { AppSettings } from 'app/features/settings/models/app-settings';
import { updateAppSettings } from 'app/state/settings/settings.actions';

export const settingsFeatureKey = 'settings';

export interface AppSettingsState {
    settings: AppSettings | undefined;
}

export const initialState: AppSettingsState = {
    settings: undefined,
};

export const reducer = createReducer(
    initialState,
    on(updateAppSettings, (state, { settings }) => ({ ...state, settings })),
);

const featureConfig = {
    name: settingsFeatureKey,
    reducer: reducer,
};
export const settingsFeature = createFeature(featureConfig);
